import { orderBy } from 'lodash/orderBy';

export const cancelSpeakerProfileBasicDetails = (speakerProfileNew, speakerProfileOld) => {
    speakerProfileNew.preferredName = speakerProfileOld.preferredName;
    speakerProfileNew.firstName = speakerProfileOld.firstName;
    speakerProfileNew.familyName = speakerProfileOld.familyName;
    speakerProfileNew.title = speakerProfileOld.title;
    speakerProfileNew.travelFromCity = speakerProfileOld.travelFromCity;
    speakerProfileNew.country = speakerProfileOld.country;
    speakerProfileNew.phoneCode = speakerProfileOld.phoneCode;
    speakerProfileNew.phone = speakerProfileOld.phone;
    speakerProfileNew.email = speakerProfileOld.email;
    speakerProfileNew.linkedInUrl = speakerProfileOld.linkedInUrl;
    speakerProfileNew.gender = speakerProfileOld.gender;
    speakerProfileNew.profileImageUrl = speakerProfileOld.profileImageUrl;
};
export const cancelSpeakerProfileDetails = (speakerProfileNew, speakerProfileOld) => {
    speakerProfileNew.feeRange = speakerProfileOld.feeRange;
    speakerProfileNew.reducedFee = speakerProfileOld.reducedFee;
    speakerProfileNew.travellingResourceProgram = speakerProfileOld.travellingResourceProgram;
    speakerProfileNew.biography = speakerProfileOld.biography;
    speakerProfileNew.servingResource = speakerProfileOld.servingResource;
    speakerProfileNew.webSiteUrl = speakerProfileOld.webSiteUrl;
    speakerProfileNew.previuoslySpokenAtYpoEvent = speakerProfileOld.previuoslySpokenAtYpoEvent;

    //cff
    speakerProfileNew.averageCffRating = speakerProfileOld.averageCffRating;
    speakerProfileNew.cffFee = speakerProfileOld.cffFee
        ? speakerProfileOld.cffFee.map(f => ({
              id: f.id,
              trainingName: f.trainingName,
              maximumFee: f.maximumFee,
              minimumFee: f.minimumFee,
          }))
        : [];
    speakerProfileNew.cffRegion = speakerProfileOld.cffRegion
        ? { id: speakerProfileOld.cffRegion.id, name: speakerProfileOld.cffRegion.name }
        : {};
    speakerProfileNew.numberofFourmPrograms = speakerProfileOld.numberofFourmPrograms;
    speakerProfileNew.qualification = speakerProfileOld.qualification;
    speakerProfileNew.retreatTopic = speakerProfileOld.retreatTopic;
    speakerProfileNew.tagLine = speakerProfileOld.tagLine;
    speakerProfileNew.cffSince = speakerProfileOld.cffSince;
};

export const setUpdatedSpeakerDetailsToReviewApplicant = (pendingORReviewApplicant, speakerDetails) => {
    pendingORReviewApplicant.firstName = speakerDetails.preferredName
        ? speakerDetails.preferredName
        : speakerDetails.firstName;
    pendingORReviewApplicant.familyName = speakerDetails.familyName;
    pendingORReviewApplicant.travelFromCity = speakerDetails.travelFromCity;
    pendingORReviewApplicant.country = speakerDetails.country;
    pendingORReviewApplicant.feeRange = speakerDetails.feeRange.feeRange;
    pendingORReviewApplicant.gender = speakerDetails.gender;
    pendingORReviewApplicant.email = speakerDetails.email;
    pendingORReviewApplicant.emailFirstName = speakerDetails.preferredName
        ? speakerDetails.preferredName
        : speakerDetails.firstName;
    pendingORReviewApplicant.profileImageUrl = `${speakerDetails.profileImageUrl}?${new Date().getTime()}`;
    pendingORReviewApplicant.categories = orderBy(
        [].concat(...speakerDetails.topics.map(topics =>
                topics.childTopics.filter(t => t.isSelected).map(topic => topic.topicName),),),
        '',
        'asc',
    );
};
